import { render, staticRenderFns } from "./ModalCodError.vue?vue&type=template&id=0b8f9197&"
import script from "./ModalCodError.vue?vue&type=script&lang=js&"
export * from "./ModalCodError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports